const speakerName = (speaker) => `${speaker?.firstName || ''} ${speaker?.lastName || ''}`.trim() || 'Speaker not assigned';

export const describeTurn = (turn, index) => [
  `${index + 1}. ${turn.title || 'Segment'}`,
  speakerName(turn.speaker),
  turn.side ? turn.side.toUpperCase() : turn.role,
].filter(Boolean).join(' - ');

export default function DebateTurnTicks({ turns, index, onSelect, disabled = false, readOnly = false, className = '' }) {
  if (!turns?.length) return null;
  return <div className={`debate-turn-ticks ${className}`.trim()} role={readOnly ? 'list' : 'group'} aria-label="Debate turns"
    onClick={event => event.stopPropagation()}>
    {turns.map((turn, turnIndex) => {
      const label = describeTurn(turn, turnIndex);
      const side = turn.side || (/^moderator$/i.test(String(turn.role || '').trim()) ? 'moderator' : '');
      const state = turnIndex === index ? 'current' : turnIndex < index ? 'done' : 'upcoming';
      const tickClass = `debate-turn-tick debate-turn-tick-${state}${side ? ` debate-turn-tick-${side}` : ''}`;
      const current = turnIndex === index ? 'step' : undefined;
      if (readOnly) {
        return <span key={turn.id} role="listitem" className={tickClass} aria-label={label} title={label} aria-current={current} />;
      }
      return <button key={turn.id} type="button" className={tickClass}
        aria-label={`Go to ${label}`} title={label} aria-current={current}
        disabled={disabled || turnIndex === index}
        onClick={() => onSelect(turnIndex)} />;
    })}
  </div>;
}
